<template>
  <div class="game">
    <h1>Game</h1>
    <p>Grab the circle in the corner and move it somewhere.</p>
    <div class="map">
      <img src="https://pic.minddnd.com/500x500/000/333/?text=Stars">
      <vue-draggable-resizable :w="50" :h="50" :x="x" :y="y" @dragging="onDrag" :parent="true" class-name="dragme" :resizable="false">
        <p>X:{{ x }}<br>Y:{{ y }}</p>
      </vue-draggable-resizable>    
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      x: 450,
      y: 450
    }
  },
  methods: {
    onDrag: function (x, y) {
      this.x = x
      this.y = y
    }
  }
}
</script>

<style lang="scss" scoped>
.map { width: 500px; height: 500px; border: 1px solid #333; position: relative; touch-action: none; }
.dragme { 
  background: #123;
  color: #ccc;
  border: solid 1px #ccc; 
  border-radius: 100%; 
  display: flex; 
  align-items: center; 
  justify-content: space-around;
  font-size: 10px; 
  cursor: grab;
  &, p { transition: all 0.4s cubic-bezier(.45,-0.35,.55,1.5); }
  transform: scale(1.01);
  &:hover { box-shadow: 0 0 10px #fff; }
  &.dragging { 
    box-shadow: 0 0 6px #aaa;
    background: transparent;
    transform: scale(1.05);
    transition: none;
    p { opacity: 0; }
  }
  p { text-align: center; margin: 0; } 
}
</style>